import React from "react";
import { Alert, Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function AccessDenied() {
  const navigate = useNavigate();
  return (
    <Container className="py-5">
      <Alert variant="danger">
        <Alert.Heading>Acesso negado</Alert.Heading>
        <p>Sua role não possui a permissão necessária para abrir esta página.</p>
        <Button variant="outline-dark" onClick={() => navigate("/dashboard")}>Voltar ao painel</Button>
      </Alert>
    </Container>
  );
}

export default AccessDenied;
